import { useEffect } from "react";
import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const useSocket = (profile, setProfile) => {
  useEffect(() => {
    if (!profile || !profile.id) {
      console.log("Socket: No profile or profile id, skipping connection.");
      return;
    }

    console.log(`Socket: Initializing connection for player ${profile.id}`);

    const echo = new Echo({
      broadcaster: "pusher",
      key: "a614b1cb6a59408511af",
      cluster: "ap2",
      forceTLS: true,
    });

    // We use the channel format 'player.{id}' as seen in the components.
    // If it fails, we might need to check if 'private-player.{id}' is required.
    const channelName = `player.${profile.id}`;
    const channel = echo.channel(channelName);

    console.log(`Socket: Subscribed to channel ${channelName}`);

    // Listening for the PlayerBalanceUpdated event.
    // The dot prefix is used for raw event names in Echo.
    channel.listen(".PlayerBalanceUpdated", (e) => {
      console.log("Socket: Received PlayerBalanceUpdated event", e);
      if (e && e.chips !== undefined) {
        setProfile((prev) => ({ ...prev, chips: e.chips }));
      }
    });

    // Pusher connection state logging
    echo.connector.pusher.connection.bind("connected", () => {
      console.log("Socket: Successfully connected to Pusher");
    });

    echo.connector.pusher.connection.bind("error", (err) => {
      console.error("Socket: Pusher connection error", err);
    });

    echo.connector.pusher.connection.bind("disconnected", () => {
      console.log("Socket: Disconnected from Pusher");
    });

    return () => {
      console.log(`Socket: Cleaning up connection for player ${profile.id}`);
      channel.stopListening(".PlayerBalanceUpdated");
      echo.disconnect();
    };
  }, [profile?.id, setProfile]);
};

export default useSocket;
